<form [formGroup]="form" *ngIf="form">
  <se-fe-form-field *ngIf="loaded"
    [seFeDataConfig]="{
      label: seFeDataLabel,
      required: isRequired,
      errorMessages: {
        required: 'SE_PO_UI_GENDER_SELECT.ERRORS.required' | translate
      }
    }">
    <se-fe-form-field-select
      [formControlName]="ngControl.name"
      [seFeDataOptions]="genderOptions"
      [seFeDataAllowClear]="!isRequired"
      [seFeDataPlaceholder]="(isRequired ? 'SE_PO_UI_GENDER_SELECT.GENDER.choose_gender' : 'SE_PO_UI_GENDER_SELECT.GENDER.no_response') | translate"
      [seFeDataComfy]="true"
      [disabled]="disabled">
    </se-fe-form-field-select>
  </se-fe-form-field>
</form>
